<template>
    <div>

        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="路径">
                <el-input v-model=formInline.miniPath clearable placeholder="路径"></el-input>
            </el-form-item>
            <el-form-item label="名称">
                <el-input v-model=formInline.schemeName clearable placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="openLink">
                <el-input v-model=formInline.openLink clearable placeholder="openLink"></el-input>
            </el-form-item>
            <el-form-item label="短链接">
              <el-input v-model=formInline.shortLink clearable placeholder="短链接"></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="formInline.expireType" clearable filterable placeholder="类型">
                    <el-option v-for="item in typeList"
                               :key="item.key"
                               :label="item.value"
                               :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="formInline.platformId" clearable filterable placeholder="平台">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="getList()">查询</el-button>
                    <el-button type="success" size="mini" @click="handleAdd()">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="urlSchemeId" label="编号" width="100"></el-table-column>
            <el-table-column prop="schemeName" label="名称" width="100"></el-table-column>
            <el-table-column prop="miniPath" label="路径" width="100"></el-table-column>
            <el-table-column prop="queryPara" label="参数" ></el-table-column>
            <el-table-column prop="schemeExprieTypeName" label="类型" width="100"></el-table-column>
            <el-table-column prop="shortLink" label="短连接" width="205"></el-table-column>
            <el-table-column prop="shortLink" label="文案示例" width="200">
                <template slot-scope="scope">
                    <span>点我 {{scope.row.shortLink.replace('http://','')}} 打开</span>
                </template>
            </el-table-column>
            <el-table-column prop="openLink" label="scheme" width="100"></el-table-column>
            <el-table-column prop="expiredTime" label="过期时间" width="168"></el-table-column>
            <el-table-column prop="platformName" label="平台" width="100"></el-table-column>
            <el-table-column label="操作" fixed="right" width="170">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini"
                                   @click="handDelete(scope.row)">删除
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="新增" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="说明">
                    <el-alert title="举例:已知小程序页面: pages/home/index?productId=1356186558330310656&productType=1   连接填写:pages/home/index,参数填写:productId=1356186558330310656&productType=1 " type="success" :closable="false">
                    </el-alert>
                </el-form-item>
                <el-form-item label="urlSchemeId" :hidden="true">
                    <el-input v-model=form.urlSchemeId></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId" clearable filterable placeholder="平台" disabled="true">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="名称" :required="true">
                    <el-input v-model=form.schemeName clearable placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="连接" :required="true">
                    <el-input v-model=form.miniPath clearable  placeholder="示例: pages/home/index"></el-input>
                    <span style="color: #df5000">不包含?及后面的参数</span>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.expireType" disabled="true" clearable filterable placeholder="类型">
                        <el-option v-for="item in typeList"
                                   :key="item.key"
                                   :label="item.value"
                                   :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参数" v-show="!miniType">
                    <el-input v-model=form.queryPara clearable placeholder="示例:productId=1356186558330310656&productType=1"></el-input>
                    <span style="color: #df5000">填写连接后台的参数(不包含?  没有参数可以不填写)</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save()">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {saveUrlSchemeApi, getUrlSchemeListApi, deleteUrlSchemeApi} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: false,
                dialogFormVisible: false,
                miniType: false,
                change:false,
                oldName:'',
                typeList: [
                    {key: 1, value: '临时'},
                    {key: 2, value: '永久'}
                ],
                form: {
                    urlSchemeId: '',
                    platformId: '',
                    miniPath: '',
                    queryPara: '',
                    expireType: 1,
                    platformId: 4,
                    openLink: '',
                    createTime: '',
                    expiredTime: ''
                },
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    miniPath: '',
                    expireType: '',
                    platformId: '',
                    openLink: '',
                    shortLink:'',
                    schemeName: '',
                    recordsTotal: 0,
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                getUrlSchemeListApi(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.schemeList.total;
                    this.listData = res.data.value.schemeList.list;
                    this.platformData = res.data.value.platFormList;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd(row){
                this.dialogFormVisible = true;
                this.oldName=''
                this.form = {
                    urlSchemeId: '',
                    platformId: 4,
                    miniPath: '',
                    queryPara: '',
                    expireType: 1,
                    openLink: '',
                    createTime: '',
                    expiredTime: '',
                    schemeName: ''
                }
                this.platformDisabled = this.form.platformId !== '';
            },
            handleEdit(data){
                if (confirm("确认修改吗？")) {
                    this.dialogFormVisible = true;
                    this.platformDisabled = true;
                    this.form = {
                        urlSchemeId: data.urlSchemeId,
                        platformId: data.platformId,
                        miniPath: data.miniPath,
                        queryPara: data.queryPara,
                        expireType: data.expireType,
                        platformId: data.platformId,
                        openLink: data.openLink,
                        createTime: data.createTime,
                        expiredTime: data.expiredTime,
                        schemeName: data.schemeName,
                        shortLink:data.shortLink
                    };
                    this.oldName=data.schemeName;
                    //this.menuTypeChange(data.menuType);
                }
            },
            handDelete(row){
                if (confirm("删除不可撤销，确认删除吗？")) {
                    this.loading = true;
                    deleteUrlSchemeApi({urlSchemeId: row.urlSchemeId}).then((res) => {
                        //console.log(res);
                        this.loading = false;
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            save(){
                console.log(this.form);
                if (this.form.schemeName == "") {
                    this.$message({
                        message: "请输入名称",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.miniPath == "") {
                    this.$message({
                        message: "请输入路径",
                        type: 'error'
                    });
                    return;
                }
                if (this.form.platformId == "") {
                    this.$message({
                        message: "请选择平台",
                        type: 'error'
                    });
                    return;
                }
                if(this.oldName==this.form.schemeName){
                    this.$message({
                        message: "修改连接时名称必须修改",
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveUrlSchemeApi(this.form).then((res) => {
                    //console.log(res);
                    this.loading = false;
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/urlscheme/miniScheme.vue